import { useMutation } from 'react-query';
import { toastr } from 'react-redux-toastr';
import AffordableWaitlistService from '../../services/affordableWaitlistService';
import { extractErrorMessage } from '../../utils/errors';

const affordableWaitlistService = new AffordableWaitlistService();

const useGenerateWaitlistV2Report = ({
  organizationId,
  propertyId,
  bedroomCount,
}: {
  organizationId: string,
  propertyId: string,
  bedroomCount: ?number,
}) =>
  useMutation(
    () =>
      affordableWaitlistService.generateAffordableWaitlistV2Report(
        organizationId,
        propertyId,
        bedroomCount,
      ),
    {
      onError: (error) => {
        toastr.error('Error', extractErrorMessage(error));
      },
    },
  );

export default useGenerateWaitlistV2Report;
